<template>
    <div class="submit-form customer-details-open">
        <button class="submit-form-button" type="submit" autocomplete="off" @click.prevent="validateAll()" v-html="$store.state.texts.submitBtn">
        </button>
        <noscript>
        </noscript>
    </div>
</template>
<script>
import $ from 'jquery'

export default {
  data () {
    return {}
  },
  created () {
    this.$store.state.form.formName = this.$store.state.texts.formName
    this.$store.state.form.target = this.$store.state.texts.target
    if (this.$route.query.CAMPAIGN) {
      this.$store.state.form.formName = this.$route.query.CAMPAIGN
    }
    if (this.$route.query.ORIGIN) {
      this.$store.state.form.target = this.$route.query.ORIGIN
    }
  },
  methods: {
    scrollTop () {
      setTimeout(() => {
        if ($('.error, .isInvalid').length) {
          $('html, body').animate({
            scrollTop: $('.error, .isInvalid').first().offset().top - 300
          }, 600)
        }
      }, 100)
    },
    validateAll () {
      this.scrollTop()
      this.$store.state.submitted = true
      // CHECK IF COMPLIENCE IS TRUE
      if (this.$store.state.buttons.complyBtn.value === true) {
        if (!this.$store.state.validation.isUserFormValid) {
          console.log("Not isUserFormValid!");
          return;
        }
      }
      
      for (var key2 in this.$store.state.validation) {
        if (this.$store.state.validation[key2] === false) {
          console.log(key2, this.$store.state.validation[key2]);
          console.log('noup check fields');
          return;
        }
      }

      // console.log(JSON.stringify(this.$store.state.form))
      parent.postMessage('Submit', '*')
      this.$http.post('https://backend-vega-rest.crm.web.belak.si/api/v2/vega/testdrive/nissan/rs', this.$store.state.form).then(response => {
        // console.log(response.status)
      }, error => {
        console.log(error)
      })
      this.$router.push({name: 'ThankYou'})

    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/form/SubmitBtn.vue